<template>
    <div class="common-head-search" :class="{ fixed: fixed }">
        <div class="common-head-left" @click="gotoBack"></div>
        <div class="common-head-main">
            <div class="search-input-box">
                <div class="search-icon"></div>
                <input
                    class="search-input"
                    v-model="keyWord"
                    placeholder="请输入搜索词"
                    @focus="sumbitKey"
                    type="text"
                />
            </div>
        </div>
        <div class="common-head-right" @click="toCartView"></div>
    </div>
</template>
<script>
import { isEmpty } from "@/utils/validation";
export default {
    name: "HeadSearch",
    props: {
        fixed: {
            type: Boolean,
            default: false,
        },
        back: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: "标题",
        },
    },
    data() {
        return {
            keyWord: "",
        };
    },
    methods: {
        gotoBack() {
            this.$router.go(-1);
        },
        /**
         * @description 设置搜索key
         */
        setKeyWord(value) {
            if (isEmpty(value)) return;
            this.keyWord = value;
        },
        /**
         * @description 提交key
         */
        sumbitKey() {
            this.$emit("search", this.keyWord);
        },
        /**
         * @description 跳转购物车
         */
        toCartView() {
            this.$router.push({
                path: "/cart",
            });
        },
    },
    computed: {},
};
</script>
<style lang="less" scoped>
.common-head-search {
    height: 90px;
    background-color: #fff;
    &.fixed {
        position: fixed;
        z-index: 10;
        width: 750px;
        top: 0px;
        left: 50%;
        margin-left: -375px;
    }
    > .common-head-left {
        float: left;
        width: 110px;
        height: 90px;
        background-image: url("../public/images/product/back-icon.png");
        background-size: 48px;
        background-repeat: no-repeat;
        background-position: center;
    }
    > .common-head-main {
        float: left;
        width: 530px;
        height: 90px;
        .search-input-box {
            position: relative;
            z-index: 10;
            overflow: hidden;
            margin: 15px 0px;
            width: 530px;
            height: 60px;
            background-color: #f2f2f2;
            border-radius: 30px;
            .search-icon {
                position: absolute;
                z-index: 12;
                width: 40px;
                height: 40px;
                top: 10px;
                left: 30px;
                background-image: url("../public/images/product/search-icon.png");
                background-size: 40px;
                background-repeat: no-repeat;
            }
            .search-input {
                padding-left: 80px;
                width: 450px;
                height: 60px;
                border: none;
                background-color: transparent;
                font-size: 28px;
                line-height: 60px;
                color: #333;
            }
        }
    }
    > .common-head-right {
        width: 110px;
        height: 90px;
        float: right;
        background-image: url("../public/images/product/search-cart-icon.png");
        background-size: 48px;
        background-repeat: no-repeat;
        background-position: center;
    }
}
</style>
